import React, { Fragment, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../../App.css";
import { Button } from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { Link } from "react-router-dom";
import constants from "../constantes";
import estilosForm from "../Formularios/FormulariosStyle";
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { format } from 'date-fns';
import NavigationAdministrador from "../Navigation/NavigationAdministrador";

const ExportCatalogo = () => {
  const styles = estilosForm();

  const [hinicio, sethInicio] = useState(new Date());
  const [hfinal, sethFinal] = useState(new Date());

  const handleChange = (e) => {
    sethInicio(e);
  };

  const handleChangeF = (e) => {
    sethFinal(e);
  };

  let fechai = format(hinicio, 'yyyy-MM-dd');
  let fechaf = format(hfinal, 'yyyy-MM-dd');
  let exportar = constants.api + "clues/az/getlayout/" + fechai + "/" + fechaf;

  return (
    <Fragment>
      <NavigationAdministrador />
      <div className="container">
        <div className="row justify-content-center" style={{ marginTop: "50px" }}>
          <div className="col-lg-12">
            <div className={styles.titulo}>
              ELIGE UN RANGO DE FECHA <br />
              PARA EXPORTAR EL CATÁLOGO
            </div>
          </div>

          <div className="col-lg-4">
            <br /><br />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Fecha Inicio"
                inputFormat="dd/MM/yyyy"
                value={hinicio}
                onChange={handleChange}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </LocalizationProvider>
          </div>

          <div className="col-lg-4">
            <br /><br />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Fecha Final"
                inputFormat="dd/MM/yyyy"
                value={hfinal}
                onChange={handleChangeF}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </LocalizationProvider>
          </div>

          <div className="col-lg-4">
            <br /><br />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ marginTop: "20px" }}
              startIcon={<SimCardDownloadIcon />}
            >
              <a 
                href={exportar} 
                style={{ 
                  color: "white", 
                  textDecoration: "none",
                  display: "block"
                }}
                download
              >
                Exportar base de datos
              </a>
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ExportCatalogo;